<template>
    <div class="modal fade" id="vincularDocenteModal" tabindex="-1" aria-labelledby="vincularDocenteModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label for="institucionIdOrigen">Institucion origen</label>
                    <select class="form-control" id="institucionIdOrigen" v-model="institucionIdOrigin" @change="changeInstitucionOrigin">
                        <option disabled selected value="">Selecciona institucion origen...</option>
                        <option v-for="institucion in instituciones" :key="institucion.id" :value="institucion.id">{{ institucion.text }}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="docenteId">Docente</label>
                    <select class="form-control" id="docenteId" v-model="selectedDocenteId">
                        <option disabled selected value="">Selecciona docente...</option>
                        <option v-for="docente in docentes" :key="docente.id" :value="docente.id">{{ docente.text }}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="institucionIdDestino">Institucion destino</label>
                    <select class="form-control" id="institucionIdDestino" v-model="institucionIdDest">
                        <option disabled selected value="">Selecciona institucion origen...</option>
                        <option v-for="institucion in instituciones" :key="institucion.id" :value="institucion.id">{{ institucion.text }}</option>
                    </select>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button id="vinculardocente" type="button" class="btn btn-primary" data-dismiss="modal" @click="save">Vincular</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'VincularDocente',
    props: ['instituciones'],
    data() {
        return {
            institucionIdOrigin: '',
            docentes: [],
            selectedDocenteId: '',
            institucionIdDest: '',
        }
    },
    methods: {
        async changeInstitucionOrigin() {
            this.docentes = await axios.get(`/docentes/porInstitucionId/${this.institucionIdOrigin}`).then(resp => resp.data);
        },
        async save() {
            await axios.post(`/docentes/vincular`, {
                persona_id: this.selectedDocenteId,
                institucion_id: this.institucionIdDest,
                status_id: 1
            }).then(resp => resp.data);

            toastr['success']('Docente vinculado');
        }
    }
}
</script>

<style>

</style>
